if (!customElements.get('tabs-component')) {
  class TabsComponent extends HTMLElement {
    constructor() {
      super();
      this.tabButtons = [];
      this.tabPanels = [];
      this.tabSelect = null;
    }

    connectedCallback() {
      this.init();
    }

    init() {
      this.tabButtons = this.querySelectorAll('.tab-button');
      this.tabPanels = this.querySelectorAll('.tab-panel');
      this.tabSelect = this.querySelector('.tab-select');

      this.tabButtons.forEach((button, index) => {
        button.addEventListener('click', () => this.switchTab(index));
      });

      if (this.tabSelect) {
        this.tabSelect.addEventListener('change', (e) => {
          this.switchTab(parseInt(e.target.value, 10));
        });
      }
    }

    switchTab(activeIndex) {
      // Update desktop buttons
      this.tabButtons.forEach((button, index) => {
        if (index === activeIndex) {
          button.setAttribute('aria-selected', 'true');
        } else {
          button.removeAttribute('aria-selected');
        }
      });

      // Update panels
      this.tabPanels.forEach((panel, index) => {
        if (index === activeIndex) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });

      // Sync dropdown if needed
      if (this.tabSelect && this.tabSelect.value !== String(activeIndex)) {
        this.tabSelect.value = String(activeIndex);
      }
    }
  }

  customElements.define('tabs-component', TabsComponent);
}
